import { snakeToCamelObj } from '@/common/converter/utils/snake-to-camel-obj'

export const normalizeTop = (rawData) => {
  return {
    bgColor: rawData?.bg_color ?? '',
    blurTargetImg: rawData?.blurtarget_img ?? '',
    button: rawData?.button ?? '',
    count: rawData?.count ?? '',
    likeStatus: rawData?.like_status ?? '',
    pageCount: rawData?.page_count ?? '',
    titleList: rawData?.title_list ?? [],
  }
}

export const normalizeImage = (rawData) => {
  return {
    thumbnail: rawData?.thumbnail ?? '',
    bannerBackground: rawData?.banner_background ?? '',
    bannerLayer: rawData?.banner_layer ?? '',
    landscape: snakeToCamelObj(rawData?.landscape) ?? {},
    landscapeLarge: snakeToCamelObj(rawData?.landscape_large) ?? {},
    portrait: snakeToCamelObj(rawData?.portrait) ?? {},
  }
}

export const normalizeRank = (rawData) => {
  return {
    order: rawData?.order ?? '',
    thumbnail: rawData?.thumbnail ?? '',
  }
}
export const normalizeTag = (rawData) => {
  return {
    topList: rawData?.top_list ?? [],
    brandList: rawData?.brand_list ?? [],
    updateList: rawData?.update_list ?? [],
  }
}

export const normalizeContextProperty = (rawData) => {
  return {
    type: rawData?.type ?? '',
    contentId: rawData?.content_id ?? '',
    description: rawData?.description ?? '',
    top: normalizeTop(rawData?.top),
    titleList: rawData?.title_list ?? [],
    metaTitleList: rawData?.meta_title_list ?? '',
    alt: rawData?.alt ?? '',
    image: normalizeImage(rawData?.image),
    bgColor: rawData?.bg_color ?? '',
    age: rawData?.age ?? '',
    likeStatus: rawData?.like_status ?? '',
    progress: rawData?.progress ?? '',
    cta: rawData?.cta ?? '',
    rank: normalizeRank(rawData?.rank),
    tag: normalizeTag(rawData?.tag),
  }
}
